import CustomerSelectionHtml from './templates/customer-selection.html';

export function CustomerSelectionDirective () {
  return {
    restrict: 'E',
    templateUrl: CustomerSelectionHtml,
    controller: 'CustomerSelectionCtrl',
    scope: {
      customer: '=',
      onSelect: '&',
      company: '='
    }
  }
}
